var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14597 3.85347C3.09952 3.80702 3.06267 3.75187 3.03753 3.69117C3.01238 3.63047 2.99944 3.56542 2.99944 3.49972C2.99944 3.43402 3.01238 3.36897 3.03753 3.30827C3.06267 3.24758 3.09952 3.19243 3.14597 3.14597C3.19243 3.09952 3.24758 3.06267 3.30827 3.03752C3.36897 3.01238 3.43402 2.99944 3.49972 2.99944C3.56542 2.99944 3.63047 3.01238 3.69117 3.03752C3.75187 3.06267 3.80702 3.09952 3.85347 3.14597L7.99972 7.29285L12.146 3.14597C12.2398 3.05215 12.367 2.99944 12.4997 2.99944C12.6324 2.99944 12.7597 3.05215 12.8535 3.14597C12.9473 3.23979 13 3.36704 13 3.49972C13 3.6324 12.9473 3.75965 12.8535 3.85347L8.7066 7.99972L12.8535 12.146C12.9473 12.2398 13 12.367 13 12.4997C13 12.6324 12.9473 12.7597 12.8535 12.8535C12.7597 12.9473 12.6324 13 12.4997 13C12.367 13 12.2398 12.9473 12.146 12.8535L7.99972 8.7066L3.85347 12.8535C3.75965 12.9473 3.6324 13 3.49972 13C3.36704 13 3.23979 12.9473 3.14597 12.8535C3.05215 12.7597 2.99944 12.6324 2.99944 12.4997C2.99944 12.367 3.05215 12.2398 3.14597 12.146L7.29285 7.99972L3.14597 3.85347Z",
    fill: "#7C63A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleCross);
export default __webpack_public_path__ + "static/media/single-cross.0e9ccf3ac5947aefc40d0f131d1e38e7.svg";
export { ForwardRef as ReactComponent };